import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptActivitiesModule } from "@org-common/lib/activities/activities.module";
import { AdaptCallToActionModule } from "@org-common/lib/call-to-action/call-to-action.module";
import { AdaptFeaturesModule } from "@org-common/lib/features/features.modules";
import { EmbedShellTourPromptDashboardElementComponent } from "app/platform/personal-dashboard/embed-shell-tour-prompt/embed-shell-tour-prompt-dashboard-element.component";
import { ThemePromptDashboardElementComponent } from "app/platform/personal-dashboard/theme-prompt/theme-prompt-dashboard-element.component";
import { AiTourPromptDashboardElementComponent } from "./ai-tour-prompt-dashboard-element/ai-tour-prompt-dashboard-element.component";
import { PersonalDashboardPageComponent } from "./personal-dashboard-page/personal-dashboard-page.component";
import { personalDashboardPageRoute } from "./personal-dashboard-page/personal-dashboard-page.route";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AdaptButtonModule,
        AdaptToolbarModule,
        AdaptActivitiesModule,
        AdaptTooltipModule,
        AdaptCallToActionModule,
        AdaptMenuModule,
        AdaptFeaturesModule,
    ],
    declarations: [
        PersonalDashboardPageComponent,
        EmbedShellTourPromptDashboardElementComponent,
        ThemePromptDashboardElementComponent,
        AiTourPromptDashboardElementComponent,
    ],
})

export class AdaptPersonalDashboardModule {
    public static readonly Routes = [
        ...personalDashboardPageRoute.routes,
    ];
}
